var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as _ from "lodash";
import * as React from "react";
import Bar from "../diagrams/Bar";
import Datatable from "../diagrams/Datatable";
import Line from "../diagrams/Line";
import Map from "../diagrams/Map";
import Pictorial from "../diagrams/Pictorial";
import Pie from "../diagrams/Pie";
import Radar from "../diagrams/Radar";
import Sunburst from "../diagrams/Sunburst";
import Tree from "../diagrams/Tree";
import { ImgStatisticsConfig } from "./ImgStatisticsConfig";
var createValSelRetArray = function (splits, pos, retArray, curValue, baseValue) {
    var end = pos === splits.length;
    if (_.isArray(curValue)) {
        if (curValue.length !== 0) {
            _.forEach(curValue, function (cV) {
                if (!end)
                    createValSelRetArray(splits, pos + 1, retArray, cV[splits[pos]], baseValue);
                else
                    retArray.push({ value: cV, object: baseValue });
            });
        }
        else {
            retArray.push({ value: undefined, object: baseValue });
        }
    }
    else {
        if (!end)
            createValSelRetArray(splits, pos + 1, retArray, curValue[splits[pos]], baseValue);
        else
            retArray.push({ value: curValue, object: baseValue });
    }
};
var valSel = function (d, sel) {
    var retArray = [];
    var s = sel.split("->");
    var startValue = d[s[0]];
    if (_.isArray(startValue)) {
        if (startValue.length > 0)
            _.forEach(startValue, function (baseVal) { return createValSelRetArray(s, 1, retArray, baseVal, baseVal); });
        else
            return [{ object: undefined, value: "Ø" }];
    }
    else
        createValSelRetArray(s, 1, retArray, startValue, startValue);
    //    console.log(retArray);
    return retArray;
};
var groupData = function (dia, filters, data) {
    var res = {};
    var keyObj = {};
    _.forEach(data, function (d) {
        var match = filters.length === 0 ? true : false;
        if (!match) {
            var lastOp_1 = false;
            _.forEach(filters, function (f) {
                var v = valSel(d, f.key)[0].value;
                var m = false;
                switch (f.match) {
                    case "=":
                        m = f.value === v;
                        break;
                    case "<>":
                        m = f.value !== v;
                        break;
                    case "in":
                        m = _.includes(f.value, v);
                        break;
                    case "not in":
                        m = !_.includes(f.value, v);
                        break;
                    case "<":
                        m = v < f.value;
                        break;
                    case ">":
                        m = v > f.value;
                        break;
                }
                if (lastOp_1)
                    match = match && m;
                else
                    match = match || m;
                lastOp_1 = f.andOperator ? f.andOperator : false;
            });
        }
        if (match) {
            var target_1 = res;
            _.forEach(dia.groupBy, function (g) {
                var v = valSel(d, g)[0].value;
                if (!keyObj[g])
                    keyObj[g] = {};
                keyObj[g][v] = true;
                if (!target_1.children)
                    target_1.children = {};
                if (!target_1.children[v])
                    target_1.children[v] = {};
                target_1 = target_1.children[v];
            });
            if (!target_1.data)
                target_1.data = [];
            target_1.data.push(d);
        }
    });
    if (dia.groupBy.length === 0) {
        res = { children: {} };
        var name_1 = "idx";
        keyObj[name_1] = {};
        _.forEach(data, function (d, idx) {
            res.children[idx] = { data: [d] };
            keyObj[name_1][idx] = true;
        });
    }
    var keys = [];
    var labels = [];
    //    console.log(keyObj);
    _.forEach(keyObj, function (k, idx) {
        var f;
        if (dia.groupByFormatters && dia.groupByFormatters[idx]) {
            f = dia.groupByFormatters[idx];
        }
        var newEle = { key: idx, values: [], names: [] };
        keys.push(newEle);
        _.forEach(k, function (v, i) {
            newEle.names.push(f ? formatValue({ object: i, count: 0 }, f) : i);
            newEle.values.push(i);
        });
    });
    return { data: res, keys: keys };
};
var recursiveAggregation = function (aggs, data) {
    if (!aggs)
        return;
    _.forEach(data, function (g) {
        if (!g.children) {
            _.forEach(aggs, function (a, i) {
                var val = 0.0;
                switch (a.type) {
                    case "count":
                        val = g.data ? g.data.length : 0;
                        break;
                    case "sum":
                        if (a.element) {
                            var sb_1 = a.element;
                            //                            console.log("sum by:", sb);
                            val = _.sumBy(g.data, function (x) { return x[sb_1]; }) * (a.factor ? a.factor : 1);
                            if (a.digits !== undefined) {
                                var pow = Math.pow(10, a.digits);
                                val = Math.round(val * pow) / pow;
                            }
                        }
                        break;
                    case "sum_percentage":
                        if (a.element && g.data) {
                            var sb_2 = a.element;
                            val = Math.floor(10 * _.sumBy(g.data, function (x) { return x[sb_2]; }) / g.data.length) / 10.0;
                        }
                    case "avg":
                        if (a.element && g.data) {
                            var sb_3 = a.element;
                            val = Math.floor(10 * _.sumBy(g.data, function (x) { return x[sb_3]; }) / g.data.length) / 10.0;
                        }
                    case "max":
                        if (a.element && g.data) {
                            var sb_4 = a.element;
                            val = _.maxBy(g.data, function (x) { return x[sb_4]; })[sb_4];
                        }
                    case "min":
                        if (a.element && g.data) {
                            var sb_5 = a.element;
                            val = _.minBy(g.data, function (x) { return x[sb_5]; })[sb_5];
                        }
                }
                if (!g.aggregations)
                    g.aggregations = aggs.map(function (x) { return 0.0; });
                g.aggregations[i] = val;
            });
        }
        else {
            recursiveAggregation(aggs, g.children);
            _.forEach(aggs, function (a, i) {
                var val = 0.0;
                _.forEach(g.children, function (c) { return val += (c.aggregations && c.aggregations[i] ? c.aggregations[i] : 0); });
                if (!g.aggregations)
                    g.aggregations = aggs.map(function (x) { return 0.0; });
                g.aggregations[i] = val;
            });
        }
    });
};
var prepareDiagramData = function (dia, toAdd, createResultFunc) {
    return new Promise(function (resolve, reject) {
        var data = getData(dia);
        if (data.length === 0)
            reject("no stat data received");
        else {
            var filters = [];
            /*if (!dia.filter)
                filters = [];
            else
                filters = dia.filter;*/
            var dx = groupData(dia, filters, _.clone(data));
            if (dx.keys && dx.keys.length > 0) {
                //                    console.log(dx);
                recursiveAggregation(dia.aggregators, { all: dx.data });
                //                    console.log(dx);
                var res = createResultFunc ? createResultFunc(dia, dx, toAdd) : createResult(dia, dx, toAdd);
                var fields_1 = [];
                _.forEach(data[0], function (v, i) { return fields_1.push(i); });
                var toRet = { data: res, keys: dx.keys, fields: fields_1 };
                if (ImgStatisticsConfig.debug)
                    console.log("toRet = ", toRet);
                resolve(toRet);
            }
            else {
                var toRet = { data: [], keys: [], fields: [] };
                if (ImgStatisticsConfig.debug)
                    console.log("toRet = ", toRet);
                resolve(toRet);
            }
        }
    });
};
export var prepareDiagramData1D = function (dia, toAdd) {
    return prepareDiagramData(dia, toAdd, function (dd, dx) {
        //        console.log(dx);
        var src = [__spreadArrays([dx.keys[0].key], dx.keys[0].values)];
        var res = [];
        var subSrc = [];
        _.forEach(dia.aggregators, function (a) {
            res.push(__assign({ name: a.label, data: [] }, toAdd));
            subSrc.push(a.label ? a.label : "");
        });
        _.forEach(dx.keys[0].values, function (k, i) {
            _.forEach(dia.aggregators, function (a, ai) {
                var val = dx.data.children[k] ? dx.data.children[k].aggregations[ai] : 0.0;
                res[ai].data.push({ value: val, name: dx.keys[0].names[i] });
                subSrc.push(val);
            });
        });
        src.push(subSrc);
        return { dataset: src, series: res };
    });
};
function createResult(dia, dx, toAdd) {
    var res = [];
    for (var i = 0; i < dx.keys[1].values.length; i++) {
        for (var j = 0; j < dia.aggregators.length; j++)
            res.push(__assign({ name: dia.aggregators[j].label, data: [] }, toAdd));
    }
    var src = [__spreadArrays([dx.keys[1].key], dx.keys[1].values)];
    _.forEach(dx.data.children, function (c, ci) {
        var subSrc = [ci];
        var i = 0;
        _.forEach(dx.keys[1].values, function (k) {
            _.forEach(dia.aggregators, function (a, ai) {
                var val = c.children[k] ? c.children[k].aggregations[ai] : 0.0;
                res[i++].data.push({ value: val, name: ci });
                subSrc.push(val);
            });
        });
        src.push(subSrc);
    });
    //    console.log(res);
    return { dataset: src, series: res };
}
var fillSunburstData = function (children, sb) {
    _.forEach(children, function (c, i) {
        var newElement = {
            name: i,
        };
        sb.push(newElement);
        if (!c.children || c.children.length === 0) {
            newElement.value = c.aggregations[0];
            newElement.aggregation = c.aggregations[0];
        }
        else {
            newElement.children = [];
            newElement.aggregation = c.aggregations[0];
            fillSunburstData(c.children, newElement.children);
        }
    });
};
export var defaultColorScheme = {
    name: "hyperLP",
    colors: [
        "#950014",
        "#ceba04",
        "#43b401",
        "#015eb4",
        "#8ECA70",
        '#F48859',
        "#30BBD0",
        "#FCCB55",
        "#C39A6C",
        "#2FB89E",
    ]
};
export var prepareDiagramDataHierarchical = function (dia, toAdd) {
    return new Promise(function (resolve, reject) {
        var data = getData(dia);
        var filters;
        if (!dia.filter)
            filters = [];
        else
            filters = dia.filter;
        var dx = groupData(dia, filters, _.clone(data));
        recursiveAggregation(dia.aggregators, { all: dx.data });
        var sb = [];
        fillSunburstData(dx.data.children, sb);
        var fields = [];
        _.forEach(data[0], function (v, i) { return fields.push(i); });
        resolve({ data: sb, fields: fields });
    });
};
export var renderTypes = {
    "sunburst": Sunburst,
    "pie": Pie,
    "bar": Bar,
    "line": Line,
    "radar": Radar,
    "tree": Tree,
    "pictorialbar": Pictorial,
    "datatable": Datatable,
    "map": Map
};
export var RenderDiagram = function (params) {
    if (!params.dia.colors)
        params.dia.colors = defaultColorScheme;
    if (!params.dia.margin)
        params.dia.margin = {};
    if (!params.dia.margin.top)
        params.dia.margin.top = 20;
    // dia.pieLabelFontSize = 14;
    // dia.innerRadius = 10;
    var ToRender = renderTypes[params.dia.type.toLowerCase()];
    if (ToRender)
        return React.createElement(ToRender, { diagram: params.dia, onFieldsLoaded: params.onFieldsLoaded, onDataChanged: params.onDataChanged, onClick: params.onClick, lng: params.lng, userData: params.userData });
    return React.createElement("div", null);
};
var applyAggregation = function (ag, d) {
    if (ag.type === "count")
        return d.length;
    if (ag.element) {
        var element_1 = ag.element;
        var val_1 = 0;
        var nzc_1 = 0;
        if (ag.type === "max") {
            var max = _.maxBy(d, function (ele) { return ele[element_1]; });
            return max ? max[element_1] : 0;
        }
        if (ag.type === "min") {
            var min = _.minBy(d, function (ele) { return ele[element_1]; });
            return min ? min[element_1] : 0;
        }
        _.forEach(d, function (ele) {
            var v = ele[element_1];
            if (v) {
                val_1 = val_1 + v;
                nzc_1++;
            }
        });
        switch (ag.type) {
            case "sum":
                return val_1;
            case "avg":
                return d.length ? val_1 / d.length : 0;
            case "avg_ignore_zero":
                return nzc_1 ? val_1 / nzc_1 : 0;
        }
    }
    return 0;
};
var applyAggregationOfAggreation = function (ag, d, co) {
    var val = _.sum(d);
    switch (ag.type) {
        case "sum":
            return val;
        case "avg":
            return co ? val / co : 0;
    }
    return 0;
};
var applyRecursiveAggregation = function (vs, dia) {
    if (vs.children) {
        _.forEach(vs.children, function (c) { return applyRecursiveAggregation(c, dia); });
        vs.nonZeroCount = _.map(dia.aggregators, function (ag, i) {
            var nzco = 0;
            var sum = 0;
            _.forEach(vs.children, function (c) {
                if (c.nonZeroCount && c.nonZeroCount[i]) {
                    sum += c.nonZeroCount[i];
                    nzco++;
                }
            });
            return nzco ? sum / nzco : 0;
        });
        vs.aggregations = _.map(dia.aggregators, function (ag, i) {
            var co = [];
            var nzco = [];
            var count = 0;
            var nzcount = 0;
            var min;
            var max;
            var maxName;
            var minName;
            _.forEach(vs.children, function (c, cn) {
                var cv = c.count ? c.count : 0;
                count += cv;
                co.push(c.count);
                var nz = c.nonZeroCount && c.nonZeroCount[i] ? c.nonZeroCount[i] : 0;
                nzcount += nz;
                nzco.push(nz);
                if (c && c.aggregations && c.aggregations[i]) {
                    var v = c.aggregations[i];
                    if (min === undefined || min > v) {
                        min = v;
                        minName = cn;
                    }
                    if (max === undefined || max < v) {
                        max = v;
                        maxName = cn;
                    }
                }
            });
            if (!vs.aggregationsMax)
                vs.aggregationsMax = _.map(dia.aggregators, function (a) { return undefined; });
            if (!vs.aggregationsMin)
                vs.aggregationsMin = _.map(dia.aggregators, function (a) { return undefined; });
            if (min !== undefined)
                vs.aggregationsMin[i] = minName;
            if (max !== undefined)
                vs.aggregationsMax[i] = maxName;
            vs.count = count;
            var cinv = 1.0 / count;
            var nzcinv = 1.0 / nzcount;
            switch (ag.type) {
                case "count":
                    return vs.count;
                case "sum":
                    return _.sum(_.map(vs.children, function (c) { return c.aggregations && c.aggregations[i] ? c.aggregations[i] : 0; } /* should not happen! */));
                case "avg":
                    return _.sum(_.map(vs.children, function (c) { return c.aggregations && c.aggregations[i] && c.count && cinv ? c.aggregations[i] * c.count * cinv : 0; } /* should not happen */));
                case "avg_ignore_zero":
                    return _.sum(_.map(vs.children, function (c) { return c.aggregations && c.aggregations[i] && c.nonZeroCount && c.nonZeroCount[i] && nzcinv ? c.aggregations[i] * c.nonZeroCount[i] * nzcinv : 0; } /* should not happen */));
                case "max":
                    var max_1 = _.max(_.map(vs.children, function (c) { return c.aggregations ? c.aggregations[i] : 0; } /* should not happen! */));
                    return max_1 ? max_1 : 0;
                case "min":
                    var min_1 = _.min(_.map(vs.children, function (c) { return c.aggregations ? c.aggregations[i] : 0; } /* should not happen! */));
                    return min_1 ? min_1 : 0;
            }
            return 0;
        });
    }
    else {
        vs.nonZeroCount = [];
        vs.aggregations = _.map(dia.aggregators, function (ag) {
            var d = vs.data ? vs.data : [];
            vs.count = d.length;
            if (vs.nonZeroCount && ag.element) {
                var ele_1 = ag.element;
                vs.nonZeroCount.push(_.filter(d, function (dx) { return dx[ele_1] !== 0; }).length);
            }
            return applyAggregation(ag, d);
        });
    }
};
var addValuesToValueSet = function (d, ele, groupBy, gidx) {
    if (gidx >= groupBy.length) {
        if (!ele.data) {
            ele.data = [];
        }
        ele.data.push(d);
        return;
    }
    var g = groupBy[gidx];
    var vals = valSel(d, g); // current value - is always an array
    _.forEach(vals, function (v) {
        if (!ele.children) {
            ele.children = {};
            ele.name = g;
            ele.aggregations = [];
        }
        if (!ele.children["_" + v.value])
            ele.children["_" + v.value] = {};
        var newEle = ele.children["_" + v.value];
        addValuesToValueSet(d, newEle, groupBy, gidx + 1);
    });
};
var calculateValueSet = function (dia, data) {
    //    if (dbg)
    //        console.log("calculateValueSet = data => ", data);
    var valueSets = {};
    var valueValues = {};
    var groupBySpecial = _.filter(dia.groupBy, function (g) { return g.indexOf("->") > 0; });
    _.forEach(data, function (d) {
        _.forEach(Object.keys(d), function (k) {
            var v = d[k]; // current value
            if (_.findIndex(dia.groupBy, function (g) { return g === k; }) >= 0 || (typeof v !== "number" && typeof v !== "object" && !_.isArray(v))) {
                var vv = "_" + v;
                if (!valueValues[k])
                    valueValues[k] = {};
                if (valueValues[k][vv] !== undefined)
                    valueValues[k][vv].count++;
                else
                    valueValues[k][vv] = { count: 1, object: v };
            }
        });
        _.forEach(groupBySpecial, function (g) {
            var k = g;
            var vals = valSel(d, k);
            _.forEach(vals, function (v) {
                //            console.log("d = ", d, ", k = ", k, ", v = ", v);
                var vv = "_" + v.value;
                if (!valueValues[k])
                    valueValues[k] = {};
                if (valueValues[k][vv] !== undefined) {
                    valueValues[k][vv].count++;
                }
                else {
                    valueValues[k][vv] = {
                        count: 1,
                        object: v.object,
                    };
                }
            });
        });
        if (ImgStatisticsConfig.debug)
            console.log(valueValues);
        addValuesToValueSet(d, valueSets, dia.groupBy, 0);
    });
    applyRecursiveAggregation(valueSets, dia);
    valueSets.foundValues = valueValues;
    //    if (dbg)
    //        console.log("valueSets = ", valueSets);
    return valueSets;
};
var filterData = function (dia, data) {
    return data;
    /*
    const filters = dia.filter ? dia.filter : [];
    const toRet = _.filter(data, d => {
        let match = filters.length === 0 ? true : false;
        if (!match) {
            let lastOp: boolean = false;
            _.forEach(filters, f => {
                const v = valSel(d, f.key)[0].value;
                let m: boolean = false;
                switch (f.match) {
                    case "=":
                        m = f.value === v;
                        break;
                    case "<>":
                        m = f.value !== v;
                        break;
                    case "in":
                        m = _.includes(f.value, v);
                        break;
                    case "not in":
                        m = !_.includes(f.value, v);
                        break;
                    case "<":
                        m = v < f.value;
                        break;
                    case ">":
                        m = v > f.value;
                        break;
                }
                if (lastOp)
                    match = match && m;
                else
                    match = match || m;
                lastOp = f.andOperator ? f.andOperator : false;
            });
        }
        return match;
    });
    return toRet;
    */
};
var formatAggregations = function (val, digits, factor) {
    var toRet = val;
    if (factor)
        toRet = toRet * factor;
    if (digits !== undefined) {
        var f = Math.pow(10, digits);
        toRet = Math.round(toRet * f) / f;
    }
    return toRet;
};
var formatValue = function (value, formatter) {
    if (!formatter)
        return value.object;
    var f = ImgStatisticsConfig.getInstance().getFormatter(formatter.type);
    //    console.log("formatter.type =", formatter.type, ", f = ", f);
    if (f) {
        return f(value.object, formatter.payload);
    }
    return value.object;
};
var prepareTheFuck = function (dia, toAdd) {
    if (ImgStatisticsConfig.debug)
        console.log(dia);
    return new Promise(function (ok, fail) {
        var unfilteredData = getData(dia);
        if (ImgStatisticsConfig.debug)
            console.log("unfiltereddata = ", unfilteredData);
        var data = filterData(dia, unfilteredData);
        if (ImgStatisticsConfig.debug)
            console.log("data = ", data);
        var valueSets = calculateValueSet(dia, data);
        if (ImgStatisticsConfig.debug)
            console.log("vs => ", valueSets);
        var foundValues;
        if (valueSets.foundValues) {
            var outerRet_1 = {};
            _.forEach(valueSets.foundValues, function (outer, outerKey) {
                var cur = {};
                outerRet_1[outerKey] = cur;
                _.forEach(outer, function (inner, innerKey) {
                    cur[("" + innerKey).substring(1)] = inner;
                });
            });
            foundValues = outerRet_1;
            if (ImgStatisticsConfig.debug)
                console.log("fv ===> ", foundValues);
        }
        var mapTheWorld = function (child) { return _.map(dia.aggregators, function (ag, i) {
            var realValue = child.aggregations && child.aggregations[i] !== undefined ? child.aggregations[i] : undefined;
            return ({
                value: realValue ? formatAggregations(realValue, ag.digits, ag.factor) : undefined,
                realValue: realValue,
                name: ag.label,
            });
        }); };
        if (!dia.aggregationGrouping) {
            var ds = _.flatten(_.map(dia.aggregators, function (ag, ai) {
                var curDs = [];
                var pushData = function (selChild, prefix) {
                    var dataValues = _.map(valueSets.children, function (child, name) {
                        //                            if (dbg)
                        //                                console.log("child = ", child);
                        var c = selChild(child);
                        //                            if (dbg)
                        //                                console.log("c =", c);
                        var realValue = c && c.aggregations && c.aggregations[ai] !== undefined ? c.aggregations[ai] : undefined;
                        return ({
                            value: realValue !== undefined ? formatAggregations(realValue, ag.digits, ag.factor) : undefined,
                            realValue: realValue,
                            name: name.substr(1)
                        });
                    });
                    curDs.push(__assign({ name: (prefix !== "" ? prefix + " - " : "") + (ag.label ? ag.label : ""), data: dataValues }, toAdd));
                };
                if (dia.groupBy.length <= 1)
                    pushData(function (c) { return c; }, "");
                else {
                    if (ImgStatisticsConfig.debug)
                        console.log("fv = ", valueSets.foundValues);
                    if (ImgStatisticsConfig.debug)
                        console.log("gb = ", dia.groupBy);
                    if (valueSets.foundValues && valueSets.foundValues[dia.groupBy[1]]) {
                        if (ImgStatisticsConfig.debug)
                            console.log("x => ", valueSets.foundValues[dia.groupBy[1]]);
                        if (ImgStatisticsConfig.debug)
                            console.log("y => ", Object.keys(valueSets.foundValues[dia.groupBy[1]]));
                        _.forEach(valueSets.foundValues ? Object.keys(valueSets.foundValues[dia.groupBy[1]]) : [], function (curVal) {
                            return pushData(function (c) { return c.children ? c.children[curVal] : c; }, formatValue({ object: curVal, count: 0 }, dia.groupByFormatters ? dia.groupByFormatters[dia.groupBy[1]] : undefined));
                        });
                    }
                }
                return curDs;
            }));
            // if (dbg)
            //     console.log("ds = ", ds);
            var series_1 = _.map(ds, function (ele) { return (__assign(__assign({}, ele), toAdd)); });
            if (dia.sortOrder && dia.sortOrder !== "None") {
                if (valueSets && valueSets.foundValues && dia.groupBy && dia.groupBy.length > 0) {
                    var oldFoundOrder_1 = _.clone(valueSets.foundValues[dia.groupBy[0]]);
                    var foundOrder_1 = {};
                    var s = series_1[0];
                    var sort = dia.sortOrder === "Asc" ? _.sortBy(s.data, function (d) { return d.realValue; }) : _.reverse(_.sortBy(s.data, function (d) { return d.realValue; }));
                    if (dia.firstNValues)
                        sort = _.take(sort, dia.firstNValues);
                    s.data = sort;
                    _.forEach(sort, function (d) { return foundOrder_1["_" + d.name] = oldFoundOrder_1["_" + d.name]; });
                    var _loop_1 = function (i) {
                        var newS = [];
                        _.forEach(sort, function (d) {
                            var val = _.find(series_1[i].data, function (x) { return x.name === d.name; });
                            newS.push(val);
                        });
                        series_1[i].data = newS;
                    };
                    for (var i = 1; i < series_1.length; i++) {
                        _loop_1(i);
                    }
                    valueSets.foundValues[dia.groupBy[0]] = foundOrder_1;
                }
            }
            var retVal = {
                foundValues: foundValues,
                keys: _.map(dia.groupBy, function (g) {
                    var f = dia.groupByFormatters ? dia.groupByFormatters[g] : undefined;
                    var names = [];
                    if (valueSets.foundValues) {
                        var fv = valueSets.foundValues[g];
                        _.forEach(fv, function (vv, idx) {
                            names.push(formatValue(vv, f));
                        });
                    }
                    return ({
                        names: names,
                        key: g,
                    });
                }),
                data: { series: series_1, name: dia.aggregators && dia.aggregators[0] && dia.aggregators[0].label ? dia.aggregators[0].label : dia.groupBy[0] },
                fields: _.map(foundValues, function (k) { return k; }),
                maxVals: _.map(valueSets.aggregationsMax, function (mv) { return (mv + "").substring(1); }),
                minVals: _.map(valueSets.aggregationsMin, function (mv) { return (mv + "").substring(1); })
            };
            if (ImgStatisticsConfig.debug)
                console.log("retVal = ", retVal);
            ok(retVal);
        }
        else {
            var names = _.map(dia.aggregators, function (ag) { return ag.label ? ag.label : ""; });
            var ds = _.map(valueSets.children, function (c, name) {
                var dataValues = [];
                if (!c.children)
                    dataValues = mapTheWorld(c);
                else
                    _.forEach(c.children, function (cc) { return dataValues.push.apply(dataValues, mapTheWorld(cc)); });
                return (__assign({ name: name, data: dataValues }, toAdd));
            });
            if (ImgStatisticsConfig.debug)
                console.log("ds = ", ds);
            var series = _.map(ds, function (ele) { return (__assign(__assign({}, ele), { label: { show: true, position: dia.swapAxis ? "right" : "top" } })); });
            var retVal = {
                foundValues: foundValues,
                keys: [{ names: names }],
                data: { series: series, name: dia.aggregators[0] },
                fields: _.map(foundValues, function (d, k) { return k; })
            };
            if (ImgStatisticsConfig.debug)
                console.log("retVal = ", retVal);
            ok(retVal);
        }
    });
};
export var prepareDiagramData2D = function (dia, toAdd) {
    // return 
    return prepareTheFuck(dia, toAdd); //.then((x) => console.log("x=", x));
    if (dia.groupBy.length > 1)
        return prepareDiagramData(dia, toAdd);
    else
        return prepareDiagramData1D(dia, toAdd);
};
function getData(dia) {
    if (typeof dia.url == "function")
        return dia.url();
    else
        return dia.url;
}
export var getRawData = function (dia) {
    if (ImgStatisticsConfig.debug)
        console.log(dia);
    var unfilteredData = getData(dia);
    if (ImgStatisticsConfig.debug)
        console.log("unfiltereddata = ", unfilteredData);
    var data = filterData(dia, unfilteredData);
    if (ImgStatisticsConfig.debug)
        console.log("data = ", data);
    return data;
};
//# sourceMappingURL=Statistics.js.map